export enum PushClientType {
  TABLELIST_IOS = 'ios',
  TABLELIST_ANDROID = 'android',
  NIGHTPRO_IOS = 'nightpro',
  NIGHTPRO_ANDROID = 'nightproAndroid',
}
